import { BLOCK_TYPES } from 'utils/clan_management/constants'
import { BATTLE_TYPES, RANDOM_BATTLE_TYPES } from 'utils/clan_management/battles'
import { PERIOD_TYPES } from 'utils/clan_management/periods'
import {
    BLOCK_TYPES_CLAN_MODES,
    BLOCK_TYPES_STATISTICS,
    PERIOD_28_DAYS,
    PERIOD_7_DAYS,
    PERIOD_1_DAY,
    PERIOD_ALL_TIME,
    STATISTICS_BATTLE_GLOBAL_MAP,
    STATISTICS_BATTLE_TYPES_RANDOM,
    STATISTICS_BATTLE_TYPES_RANKED,
    STATISTICS_BATTLE_TYPES_SKIRMISHES,
    STATISTICS_BATTLE_TYPES_TEAM,
    STATISTICS_BATTLE_TYPES_FORT,
} from './translations'

import {
    StatisticsOverallTooltip,
    Statistics28DaysTooltip,
    Statistics7DaysTooltip,
    Statistics1DayTooltip,
    StatisticsRandomDefaultBattleTypeTooltip,
    StatisticsRandomEpicBattleTypeTooltip,
} from './tooltips'

export const PERIODS_BY_BLOCK_TYPE = {
    [BLOCK_TYPES.CLAN_MODES]: [
        {
            name: 'periods',
            value: PERIOD_TYPES.MONTH,
            caption: PERIOD_28_DAYS,
            tooltipId: Statistics28DaysTooltip.id,
        },
        {
            name: 'periods',
            value: PERIOD_TYPES.WEEK,
            caption: PERIOD_7_DAYS,
            tooltipId: Statistics7DaysTooltip.id,
        },
        {
            name: 'periods',
            value: PERIOD_TYPES.DAY,
            caption: PERIOD_1_DAY,
            tooltipId: Statistics1DayTooltip.id,
        },
    ],
    [BLOCK_TYPES.STATISTICS]: [
        {
            name: 'periods',
            value: PERIOD_TYPES.ALL,
            caption: PERIOD_ALL_TIME,
            tooltipId: StatisticsOverallTooltip.id,
        },
        {
            name: 'periods',
            value: PERIOD_TYPES.MONTH,
            caption: PERIOD_28_DAYS,
            tooltipId: Statistics28DaysTooltip.id,
        },
        {
            name: 'periods',
            value: PERIOD_TYPES.WEEK,
            caption: PERIOD_7_DAYS,
            tooltipId: Statistics7DaysTooltip.id,
        },
        {
            name: 'periods',
            value: PERIOD_TYPES.DAY,
            caption: PERIOD_1_DAY,
            tooltipId: Statistics1DayTooltip.id,
        },
    ],
}

export const TABS_BLOCK_TYPES = [
    {
        value: BLOCK_TYPES.CLAN_MODES,
        caption: BLOCK_TYPES_CLAN_MODES,
    },
    {
        value: BLOCK_TYPES.STATISTICS,
        caption: BLOCK_TYPES_STATISTICS,
    },
]

export const COMMON_STATISTICS_BATTLE_TYPES = [
    {
        value: BATTLE_TYPES.RANDOM,
        caption: STATISTICS_BATTLE_TYPES_RANDOM,
    },
    {
        value: BATTLE_TYPES.RANKED,
        caption: STATISTICS_BATTLE_TYPES_RANKED,
    },
    {
        value: BATTLE_TYPES.TEAM,
        caption: STATISTICS_BATTLE_TYPES_TEAM,
    },
    {
        value: BATTLE_TYPES.SKIRMISHES,
        caption: STATISTICS_BATTLE_TYPES_SKIRMISHES,
    },
    {
        value: BATTLE_TYPES.ATTACKS,
        caption: STATISTICS_BATTLE_TYPES_FORT,
    },
]

export const STATISTICS_BATTLE_TYPES = [
    ...COMMON_STATISTICS_BATTLE_TYPES,
    {
        value: BATTLE_TYPES.GLOBAL_MAP,
        caption: STATISTICS_BATTLE_GLOBAL_MAP,
    },
]

export const RANDOM_BATTLE_TYPES_FILTER_ITEMS = [
    {
        name: 'periods',
        value: RANDOM_BATTLE_TYPES.DEFAULT,
        caption: '15x15',
        tooltipId: StatisticsRandomDefaultBattleTypeTooltip.id,
    },
    {
        name: 'periods',
        value: RANDOM_BATTLE_TYPES.EPIC,
        caption: '30x30',
        tooltipId: StatisticsRandomEpicBattleTypeTooltip.id,
    },
]



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/ClanManagement/constants.js